import React from "react";

import { Brand } from "@ds-developer/models";
import { HeaderProps } from "./types";
import { LogoAa } from "./logo_aa";
import { LogoBsm } from "./logo_bsm";
import { Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  header: {
    width: "100%",
  },
  headerBsm: {
    background: "var(--BSM-Orange, #F9812A)",
    padding: theme.spacing(2, 0, 2, 0),
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
    color: "white",
  },
  headerAa: {
    background: "var(--primary-colours-ffd-300-aa-yellow, #FFD300)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    padding: theme.spacing(2, 0, 2, 0),
    color: "var(--mono-darkest, #2B2929)",
  },
  headerLogo: {
    with: "auto",
    height: "100%",
  },
  main: {
    margin: "0 100px",
    [theme.breakpoints.down("sm")]: {
      margin: "0 16px",
    },
    display: "flex",
    flexDirection: "column",
    gap: 24,
  },
  logoText: {
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  logoAA: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      height: "32px",
      width: "47px",
    },
    "& svg": {
      maxWidth: "100%",
      maxHeight: "100%",
    },
  },
  logoBsm: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      height: "20px",
      width: "64px",
    },
    "& svg": {
      maxWidth: "100%",
      maxHeight: "100%",
    },
  },
}));

export const Header: React.FC<HeaderProps> = ({
  brand = Brand.Aad,
  title = "",
}) => {
  const classes = useStyles();
  return (
    <header
      className={clsx(classes.header, {
        [classes.headerBsm]: brand === Brand.Bsm,
        [classes.headerAa]: brand === Brand.Aad,
      })}
    >
      <div className={classes.main}>
        {brand && brand === Brand.Bsm ? (
          <div className={classes.logoBsm}>
            <LogoBsm />
          </div>
        ) : (
          <div className={classes.logoAA}>
            <LogoAa />
          </div>
        )}
        {title && <Typography className={classes.logoText}>{title}</Typography>}
      </div>
    </header>
  );
};
